const clearCookiesAndReload = () => {
    window.sessionStorage.clear()
    window.localStorage.clear()
    window.location.reload()
}

export default clearCookiesAndReload
